import React, { useEffect, useState } from "react";
import { useAuth } from "../AuthProvider";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "/api";

function UserProfileModal({ isOpen, onClose }) {
  const { token } = useAuth();

  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const formatDate = (value) => {
    if (!value) return "-";

    try {
      return new Date(value).toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    } catch {
      return value;
    }
  };

  useEffect(() => {
    if (!isOpen) return;

    const fetchProfile = async () => {
      setLoading(true);
      setError("");

      try {
        const authToken =
          token ||
          localStorage.getItem("token") ||
          localStorage.getItem("access_token");

        if (!authToken) {
          throw new Error("Session login tidak ditemukan. Silakan login ulang.");
        }

        const res = await fetch(`${API_BASE}/license/status`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });

        const data = await res.json();

        if (!res.ok) {
          throw new Error(data?.detail || "Gagal mengambil data profil.");
        }

        setProfile(data);
      } catch (err) {
        setError(err.message || "Terjadi kesalahan saat mengambil profil.");
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [isOpen, token]);

  if (!isOpen) return null;

  const planLabel =
    profile?.is_premium_active ? "Premium" : "Free";

  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center bg-slate-950/70 px-4 backdrop-blur-md">
      <div className="relative w-full max-w-md rounded-[28px] border border-white/10 bg-slate-900 p-6 shadow-2xl">
        <button
          type="button"
          onClick={onClose}
          className="absolute right-5 top-5 text-slate-500 transition hover:text-white"
          aria-label="Tutup profil akun"
        >
          ✕
        </button>

        <div className="mb-6">
          <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-indigo-500/20 ring-1 ring-indigo-400/30">
            <span className="text-lg font-bold text-indigo-300">SV</span>
          </div>

          <h2 className="text-2xl font-bold text-white">Profil Akun</h2>
          <p className="mt-2 text-sm leading-6 text-slate-400">
            Informasi akun dasar yang digunakan untuk akses Saham Vista.
          </p>
        </div>

        {loading && (
          <div className="rounded-2xl border border-white/10 bg-slate-950/40 p-4 text-sm text-slate-300">
            Memuat profil...
          </div>
        )}

        {error && (
          <div className="rounded-2xl border border-rose-500/20 bg-rose-500/10 p-4 text-sm text-rose-300">
            {error}
          </div>
        )}

        {!loading && !error && profile && (
          <div className="space-y-4">
            <div className="rounded-2xl border border-white/10 bg-slate-950/40 p-4">
              <div className="text-xs font-semibold uppercase tracking-widest text-slate-500">
                Akun
              </div>

              <div className="mt-4 space-y-3 text-sm">
                <div className="flex justify-between gap-4">
                  <span className="text-slate-500">Nama</span>
                  <span className="max-w-[220px] truncate text-right font-medium text-white">
                    {profile.name || "-"}
                  </span>
                </div>

                <div className="flex justify-between gap-4">
                  <span className="text-slate-500">Email</span>
                  <span className="max-w-[220px] truncate text-right font-medium text-white">
                    {profile.email || "-"}
                  </span>
                </div>

                <div className="flex justify-between gap-4">
                  <span className="text-slate-500">Role</span>
                  <span className="font-medium capitalize text-white">
                    {profile.role || "-"}
                  </span>
                </div>
              </div>
            </div>

            <div className="rounded-2xl border border-emerald-500/20 bg-emerald-500/10 p-4">
              <div className="text-xs font-semibold uppercase tracking-widest text-emerald-400">
                Paket
              </div>

              <div className="mt-4 space-y-3 text-sm">
                <div className="flex justify-between gap-4">
                  <span className="text-slate-400">Status Paket</span>
                  <span className="font-semibold text-white">
                    {planLabel}
                  </span>
                </div>

                <div className="flex justify-between gap-4">
                  <span className="text-slate-400">Aktif sampai</span>
                  <span className="font-medium text-white">
                    {profile.is_premium_active
                      ? formatDate(profile.premium_until)
                      : "-"}
                  </span>
                </div>

                <div className="flex justify-between gap-4">
                  <span className="text-slate-400">Sisa hari</span>
                  <span className="font-medium text-white">
                    {profile.is_premium_active
                      ? `${profile.days_left} hari`
                      : "-"}
                  </span>
                </div>
              </div>
            </div>

            <div className="rounded-2xl border border-white/10 bg-slate-950/30 p-4 text-xs leading-5 text-slate-500">
              Saham Vista hanya menyimpan informasi dasar akun Google seperti nama
              dan email untuk kebutuhan login, aktivasi paket, dan manajemen akses.
            </div>

            <button
              type="button"
              onClick={onClose}
              className="w-full rounded-2xl bg-indigo-500 px-4 py-3 text-sm font-semibold text-white transition hover:bg-indigo-400"
            >
              Tutup
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default UserProfileModal;